module.exports = __webpack_public_path__ + "static/logo-058bb637a13bddbab3cbf7b527b27f43.png";